export const SET_MODAL_STATUS = "SET_MODAL_STATUS";
